import { Routes } from '@angular/router';
import { permissionGuard } from '@core/auth/permission.guard';
import { APP_PERMISSIONS } from '@core/constants/permission.constants';
import { APP_ROUTES } from '@core/constants/routes.constants';

export const hazardCatalogRoutes: Routes = [
  {
    title: 'pagesTitles.hazardCatalog',
    path: APP_ROUTES.HAZARD_CATALOG,
    canActivate: [permissionGuard(APP_PERMISSIONS.HazardCatalogRead)],
    loadComponent: () => import('./pages/hazard-catalog').then((m) => m.HazardCatalog),
  },
];
